// ================================================================
// Credentials Store — کلیدهای API مدل‌های AI (backend / async)
// ================================================================
// به API /api/credentials وصل می‌شه. کلید خام هیچ‌وقت از سرور برنمی‌گرده؛
// فقط { id, aiProvider, label, createdAt } در دسترسه.

import { apiRequest } from './apiClient.js';

// نگاشت مدل نود AI → provider کلید
export const MODEL_TO_PROVIDER = {
  'gpt-4o': 'openai',
  'gpt-4o-mini': 'openai',
  'claude': 'anthropic',
  'gemini': 'google',
  'swiss': 'swiss'
};

// لیست providerها برای صفحه‌ی مدیریت (برچسب‌ها از i18n)
export const PROVIDERS = [
  { key: 'openai',    labelKey: 'credentials.providers.openai' },
  { key: 'anthropic', labelKey: 'credentials.providers.anthropic' },
  { key: 'google',    labelKey: 'credentials.providers.google' },
  { key: 'swiss',     labelKey: 'credentials.providers.swiss' }
];

// لیست credentialها — اگر provider داده شد، فیلتر می‌شه
// خروجی: آرایه‌ای از { id, aiProvider, label, createdAt }
export async function getCredentials(provider) {
  const q = provider ? '?provider=' + encodeURIComponent(provider) : '';
  const data = await apiRequest('/api/credentials' + q);
  return data.credentials || [];
}

// ساخت credential جدید
export async function createCredential(aiProvider, label, key) {
  const data = await apiRequest('/api/credentials', {
    method: 'POST',
    body: JSON.stringify({ aiProvider, label, key: String(key) })
  });
  return data.credential;
}

// حذف credential
export async function deleteCredential(id) {
  return apiRequest('/api/credentials/' + encodeURIComponent(id), { method: 'DELETE' });
}
